module.exports = __webpack_public_path__ + "img/01-T.7d6c8d28.png";